module.exports = __webpack_public_path__ + "media/MRI4-ad.640140bd.mp3";